export default "__VITE_ASSET__CpKcS_vZ__"